// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--3-0qH"};